var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 16.5C24 21.1945 20.1945 25 15.5 25C10.8056 25 7 21.1945 7 16.5C7 11.8056 10.8056 8 15.5 8C16.438 8 17.3405 8.15193 18.1842 8.43252",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2933 18.752C19.2722 20.3375 17.4117 21.3028 15.4099 21.2855C13.408 21.2682 11.5675 20.271 10.5789 18.6681M11.1861 15.1181C11.1861 14.5006 11.7297 14 12.4004 14C13.071 14 13.6147 14.5006 13.6147 15.1181M17.2575 15.1181C17.2575 14.5006 17.8012 14 18.4718 14C19.1425 14 19.6861 14.5006 19.6861 15.1181",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7764 13.3684H22.4343V11.3553H20.4211V10.0132H22.4343V8H23.7764V10.0132H25.7895V11.3553H23.7764V13.3684Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddEmoji);
export default __webpack_public_path__ + "static/media/add-emoji.9fee21703af278866de2462ade39d4ba.svg";
export { ForwardRef as ReactComponent };